import { audio } from '../game/Audio';

interface BeforeInstallPromptEvent extends Event {
  readonly platforms: string[];
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

let deferred: BeforeInstallPromptEvent | null = null;

window.addEventListener('beforeinstallprompt', (e: Event) => {
  e.preventDefault();
  deferred = e as BeforeInstallPromptEvent;
  window.dispatchEvent(new CustomEvent('lavascend:install-available'));
});

window.addEventListener('appinstalled', () => {
  deferred = null;
  window.dispatchEvent(new CustomEvent('lavascend:installed'));
});

export function canInstall(): boolean { return deferred !== null; }
export async function promptInstall(): Promise<'accepted' | 'dismissed' | 'unavailable'> {
  if (!deferred) return 'unavailable';
  await deferred.prompt();
  const choice = await deferred.userChoice;
  deferred = null;
  if (choice.outcome === 'accepted') audio.install();
  return choice.outcome;
}
